import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    card: {
      width: '100%',
      padding: '2rem 2.5rem',
      borderRadius: 8,
      position: 'relative',
      '& > svg': {
        position: 'absolute',
        top: '1rem',
        right: '1rem',
        fontSize: '1.6rem',
        color: '#727970',
      },
      '& > .MuiTypography-h2': {
        margin: 0,
        paddingBottom: '0.2rem',
        fontSize: '2.4rem',
        fontWeight: 500,
      },
      '& > .MuiTypography-subtitle2': {
        fontSize: '1.2rem',
      },
    },
    tooltip: {
      backgroundColor: '#505356',
      color: '#FFFFFF',
      maxWidth: '27rem',
      fontSize: '1.2rem',
      padding: '0.4rem 0.8rem',
      border: 'none',
      borderRadius: 5,
    },
  }),
)
